import s3 from '../../s3';

export const BUCKETS_LIST_REQUEST = 'BUCKETS_LIST_REQUEST';
function actionListRequest() {
    return {
        type: BUCKETS_LIST_REQUEST,
    };
}

export const BUCKETS_LIST_SUCCESS = 'BUCKETS_LIST_SUCCESS';
function actionListReceive({ Buckets }) {
    return {
        type: BUCKETS_LIST_SUCCESS,
        data: { Buckets },
    };
}

export const BUCKETS_LIST_FAILURE = 'BUCKETS_LIST_FAILURE';
function actionListFailure() {
    return {
        type: BUCKETS_LIST_FAILURE,
    };
}

export const BUCKETS_LIST_ADD = 'BUCKETS_LIST_ADD';
export function actionListAdd({ Bucket }) {
    return {
        type: BUCKETS_LIST_ADD,
        data: { Bucket },
    };
}

export function asyncActionList() {
    return async function(dispatch) {
        dispatch(actionListRequest());

        try {
            const {
                data: { Buckets },
            } = await s3.listBuckets();

            dispatch(actionListReceive({ Buckets }));
        } catch (reason) {
            dispatch(actionListFailure());
            throw reason;
        }
    };
}

export const loadBucketsInitially = () => (dispatch, getState) => {
    const { listLoading, listLoaded } = getState().storageBuckets;
    if (listLoading || listLoaded) {
        return;
    }
    return dispatch(asyncActionList());
};
